/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ paid: NonNullable<unknown>, fee: NonNullable<unknown> }} Order_Gift_Shipping_PartialInputs */

const vi_order_gift_shipping_partial = /** @type {(inputs: Order_Gift_Shipping_PartialInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.paid} / ${i?.fee} (còn thiếu)`)
};

/**

* @param {Order_Gift_Shipping_PartialInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_gift_shipping_partial = /** @type {((inputs: Order_Gift_Shipping_PartialInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Gift_Shipping_PartialInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_gift_shipping_partial(inputs)
});